import { render } from "./Businesses.Manage.vue?vue&type=template&id=2fc6d409"
import script from "./Businesses.Manage.vue?vue&type=script&lang=js"
export * from "./Businesses.Manage.vue?vue&type=script&lang=js"

import "./Businesses.Manage.vue?vue&type=style&index=0&id=2fc6d409&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__